module.exports = __webpack_public_path__ + "static/media/8.56fb4b1a.jpg";